import { IProductBlacklistEntry } from '@/services/banking/ProductBlacklistService';

export const isFetching = (state: any, isFetching: boolean) => {
    state.isFetching = isFetching;
}

export const allEntries = (state: any, entries: IProductBlacklistEntry[]) => {
    state.allEntries = entries;
}
